import * as PIXI from 'pixi.js'
import * as CSS from 'utils/css.js'
import * as Utils from 'utils/math.js'
import TweenMax from 'gsap'
import Emitter from 'core/Emitter'
import Detector from 'utils/Detector'
import 'styles/components/filters.styl'

export default class Filters {
  constructor (opts) {
    this.size = opts.size
    this.resources = opts.resources
    this.offsetHeight = 0
    this.coverBounds = null
    this.isHidden = true
    this.isMenuTransparent = true

    this.isMobile = Detector.isMobile()

    this.prefix = CSS.getPrefix()

    this.scrollY = {
      dest: 0,
      current: 0
    }

    this.dom = {
      filtersSection: document.querySelector('.filters-section'),
      filtersContainer: document.querySelector('.filters-section .filters-container'),
      filtersLeftPart: document.querySelector('.filters-section .filters__column--left'),
      filtersRightPart: document.querySelector('.filters-section .filters__column--right'),
      filtersQuestion: document.querySelector('.filters-section .filters__question'),
      filtersChoices: document.querySelector('.filters-section .filters__choices')
    }

    this.bounds = {
      filtersSection: null,
      filtersContainer: null
    }

    this.motions = {
    }
  }

  getBounds () {
    this.bounds.filtersContainer = CSS.getSize(this.dom.filtersContainer)
    this.bounds.filtersContainer.top = this.dom.filtersContainer.offsetTop

    this.bounds.filtersChoices = CSS.getSize(this.dom.filtersChoices)
  }

  positionDom () {
    this.dom.filtersContainer.style.top = `${this.coverBounds.top + this.coverBounds.height}px`
  }

  showDom () {
    if (!this.isHidden) return

    this.isHidden = false
    this.dom.filtersSection.classList.remove('is-hidden')
  }

  hideDom () {
    if (this.isHidden) return

    this.isHidden = true
    this.dom.filtersSection.classList.add('is-hidden')
  }

  update ({time, scrollY}) {
    this.scrollY = scrollY

    let limitIn = (this.bounds.filtersContainer.top - this.size.h)
    let limitOutVp = limitIn + this.offsetHeight + this.size.h

    let vp = this.scrollY.current >= limitIn &&
    this.scrollY.current <= limitOutVp

    if (vp) {
      this.showDom()
      if (this.oldPosition !== -this.scrollY.current) {
        this.oldPosition = -this.scrollY.current
        this.dom.filtersSection.style[this.prefix] = CSS.getMatrixTransform(0, (this.oldPosition))
      }
      // this.dom.filtersQuestion.style[this.prefix] = CSS.getMatrixTransform(0, (-this.scrollY.current * 0.1))
    } else {
      if (this.oldPosition !== -limitOutVp) {
        this.oldPosition = -limitOutVp
        this.dom.filtersSection.style[this.prefix] = CSS.getMatrixTransform(0, (this.oldPosition))
      }
      // this.hideDom()
    }

    limitIn = (this.bounds.filtersContainer.top)
    let limitOut = limitIn + this.offsetHeight - this.size.h
    vp = this.scrollY.current >= limitIn && this.scrollY.current <= limitOut
    if (vp) {
      this.dom.filtersLeftPart.style[this.prefix] = CSS.getMatrixTransform(0, this.scrollY.current - limitIn)
      this.setMenuWhite()
    } else {
      // this.dom.filtersLeftPart.style[this.prefix] = CSS.getMatrixTransform(0, this.scrollY.current - limitIn)

      if (this.scrollY.current <= limitIn) {
        this.setMenuTransparent()
      }
    }

    // // limitOutVp = limitIn + this.offsetHeight - this.size.h - this.bounds.filtersContainer.paddingTop
    //
    // vp = this.scrollY.current >= limitIn &&
    // this.scrollY.current <= limitOut
    // if (vp) {
    //   this.dom.filtersSection.style[this.prefix] = CSS.getMatrixTransform(0, (-this.bounds.filtersContainer.top))
    //
    //   let norm = Utils.clamp((this.scrollY.current - limitIn) / (limitOut), 0, 1)
    //   let scroll = this.scrollY.current - limitIn
    //   this.dom.filtersChoices.style[this.prefix] = CSS.getMatrixTransform(0, -scroll)
    //
    //   this.lockPosition = true
    //   this.setMenuWhite()
    // } else {
    //   this.addOffset = false
    //
    //   if (this.scrollY.current <= limitIn) {
    //     this.setMenuTransparent()
    //     this.dom.filtersChoices.style[this.prefix] = ''
    //   }
    //
    //   if (this.scrollY.current >= limitOut) {
    //     this.addOffset = true
    //
    //     if (this.scrollY.current <= limitOut) {
    //       this.dom.filtersSection.style[this.prefix] = CSS.getMatrixTransform(0, (-this.scrollY.current + this.offsetHeight))
    //     }
    //   }
    //
    //   this.lockPosition = false
    //   // this.dom.filtersSection.style[this.prefix] = ''
    // }
    //   if (!this.lockPosition) {
    //     this.lockedPosition = -this.scrollY.current
    //   }
    //
    //   this.lockPosition = true
    //   let norm = Utils.clamp((this.scrollY.current - limitIn) / (limitOut), 0, 1)
    //   let scroll = this.scrollY.current - limitIn
    //   this.dom.filtersRightPart.style[this.prefix] = CSS.getMatrixTransform(0, -scroll)
    //   this.dom.filtersSection.style[this.prefix] = CSS.getMatrixTransform(0, this.lockedPosition)
    //
    //   this.setMenuWhite()
    // } else if (this.scrollY.current < limitIn) {
    //   // this.dom.filtersRightPart.style[this.prefix] = ''
    //   this.lockPosition = false
    //   this.setMenuTransparent()
    // } else {
    //   this.lockPosition = false
    // }
  }

  setMenuWhite () {
    if (!this.isMenuTransparent) return

    this.isMenuTransparent = false
    Emitter.emit('HIDE_MENU')
  }

  setMenuTransparent () {
    if (this.isMenuTransparent) return

    this.isMenuTransparent = true
    Emitter.emit('SET_MENU_TRANSPARENT')
  }

  resize (size, coverBounds) {
    this.size = size
    this.coverBounds = coverBounds

    this.positionDom()
    this.getBounds()

    let padding = this.bounds.filtersContainer.paddingTop
    let hW = (this.size.w / 2) - (padding)
    let hH = Utils.clamp(this.size.h * 0.8, 300, (this.isMobile) ? 400 : 600)

    let leftStyle = {
      position: 'absolute',
      top: `${padding}px`,
      left: `${padding}px`,
      width: `${hW}px`,
      height: `${this.size.h - (padding * 2)}px`
    }

    let rightStyle = {
      position: 'absolute',
      top: `${padding}px`,
      right: `${padding}px`,
      width: `${hW}px`
      // height: `${hH}px`
    }

    Object.assign(this.dom.filtersLeftPart.style, leftStyle)
    Object.assign(this.dom.filtersRightPart.style, rightStyle)
    // this.dom.filtersChoices.style.paddingTop = `${hH / 5}px`

    this.getBounds()
    this.offsetHeight = this.bounds.filtersChoices.height
    // this.offsetFakeHeight = hH
    this.dom.filtersContainer.style.minHeight = `${this.offsetHeight}px`
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Home/classes/Filters.js
 **/